import {
    LOAD_PROMOTION_PROVIDERS_SUCCESS,
    LOAD_SELECTED_PROMO_PROVIDER_SUCCESS
} from '../../actions/types';

const INITIAL_STATE = {
    providers: null,
    selectedPromoProvider: null,
    type: null
};

export default (state = INITIAL_STATE, action) => {
    const { type, payload } = action;

    switch (type) {
        case LOAD_PROMOTION_PROVIDERS_SUCCESS:
            return {
                ...state,
                providers: payload
            };
        case LOAD_SELECTED_PROMO_PROVIDER_SUCCESS:
            return {
                ...state,
                selectedPromoProvider: {
                    id: payload.id,
                    type: payload.type,
                    settings: payload.settings
                },
                chainLevelPromotionSettings: payload.chainLevelPromotionSettings,
                chainPromotionPartnerType: payload.chainPromotionPartnerType,
                type: payload.type
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/promotionProviders/PromotionProvidersReducer.js